import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const FavoritesHeader = () => {
  return (
    <Box 
      sx={{ 
        bgcolor: '#B2C4FF', 
        py: 6, 
        textAlign: 'left',
        borderRadius: '16px',
        mb: 4,
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <Container maxWidth="xl">
        <Typography variant="h3" fontWeight="bold" color="#0E2465" sx={{ mb: 1 }}>
          Tus favoritos,<br />siempre a la mano
        </Typography>
        <Typography variant="body1" color="#0E2465" sx={{ opacity: 0.8 }}>
          Encuentra rápidamente los servicios que más te interesan y accede a ellos cuando los necesites.
        </Typography>
      </Container>
    </Box>
  );
};

export default FavoritesHeader;
